import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import data from './language.json';
import { defaultLanguage } from '../constants/flags';
import { LANGUAGE } from '../constants/storageKeys';

export const i18nReady = i18n.use(LanguageDetector).init({
    resources: data,
    fallbackLng: defaultLanguage,

    debug: true,

    ns: ["translations"],
    defaultNS: "translations",

    detection: {
        order: ['localStorage', 'navigator'],
        lookupLocalStorage: LANGUAGE,
        caches: ['localStorage'],
    },

    interpolation: {
        escapeValue: false,
    },

    react: {
        useSuspense: false,
    }
});

export default i18n;
